import React from "react";
import { Icon } from "./Icon";

interface Apps32Props {
  size?: number;
  className?: string;
  color?: string;
}

export const Apps32: React.FC<Apps32Props> = ({ size, className, color }) => {
  return (
    <Icon size={size} className={className} color={color}>
      <path d="M633.6 83.2h-240c-89.6 0-160 70.4-160 160v537.6c0 89.6 70.4 160 160 160h240c86.4 0 160-70.4 160-160v-537.6c0-89.6-70.4-160-160-160zM393.6 147.2h240c54.4 0 96 41.6 96 96v428.8h-432v-428.8c0-54.4 41.6-96 96-96zM633.6 876.8h-240c-54.4 0-96-41.6-96-96v-44.8h432v44.8c0 54.4-41.6 96-96 96z" />
      <path d="M544 806.4c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z" />
    </Icon>
  );
};
